import React from 'react';

import { Link as RouterLink } from '~/lib/react-router-dom';

import { Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import type { CompetitorProperty } from '~/types/services/priceParrot';

import CompetitorOfferLeFlashChip from './CompetitorOfferLeFlashChip';
import CompetitorOfferMatchChip from './CompetitorOfferMatchChip';
import CompetitorOfferPropertyLink from './CompetitorOfferPropertyLink';
import { formatDate, offerPath } from './utils';

interface Props {
  property: CompetitorProperty;
}

export default function CompetitorOfferLeOffersTable({ property }: Props) {
  if (!property.leOffers.length) {
    return (
      <Typography color="text.secondary">
        {property.lePropertyIds.length
          ? 'No approved Flash offer has been scheduled on the matched properties.'
          : 'Not matched to a Flash property.'}
      </Typography>
    );
  }
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Flash ID</TableCell>
          <TableCell>Offer</TableCell>
          <TableCell>Property ID</TableCell>
          <TableCell>Matching</TableCell>
          <TableCell>On sale</TableCell>
          <TableCell>LE Flash status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {property.leOffers.map((offer) => (
          <TableRow key={`${offer.offerId}:${offer.lePropertyId}`}>
            <TableCell>
              <Link
                component={RouterLink}
                to={offerPath(offer.offerId)}
                target="_blank"
                rel="noopener noreferrer"
                variant="body2"
              >
                {offer.offerId}
              </Link>
            </TableCell>
            <TableCell>{offer.offerName ?? '—'}</TableCell>
            <TableCell>
              <CompetitorOfferPropertyLink propertyId={offer.lePropertyId} vendorId={offer.leVendorId} />
            </TableCell>
            <TableCell>
              <CompetitorOfferMatchChip matchTier={property.matchTier} />
            </TableCell>
            <TableCell>
              {formatDate(offer.availabilityStartDate)} – {formatDate(offer.availabilityEndDate)}
            </TableCell>
            <TableCell>
              <CompetitorOfferLeFlashChip status={offer.onSaleStatus} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
